module.exports = __webpack_public_path__ + "static/media/third_declension1_img.19571432.JPG";